import React, { useState, useRef } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import configs from "constants/configs";
import { API_AUTH } from "service/common";
import { useSelector, useDispatch } from "react-redux";
import { Cookies } from "react-cookie";
import TaiSanPrint from "components/GenericComponent/ContentPrint/TaiSanPrint";
import moment from "moment";
export const BtnXuatDanhSach = () => {
  const componentRef = useRef();
  const [dataPrint, setDataPrint] = useState({});
  const dataSearch = useSelector((state) => state.dataSearchTaiSan); //dataSearchTaiSan dinh nghia o rootreducer
  const xuatExcel = () => () => {
    let { tentaisan, tenkhachhang, kho, trangthai, tinhtrang, ghichu } =
      dataSearch;

    const cookies = new Cookies();
    let link = configs.endPoint;
    var apilink = cookies.get("apilink");
    if (typeof apilink != "undefined" && apilink.length > 0) {
      link = apilink;
    }

    link =
      link +
      `quan-ly-tai-san/tai-san-xuat-excel-data?tentaisan=${tentaisan}&tenkhachhang=${tenkhachhang}&kho=${kho}&trangthai=${trangthai}&tinhtrang=${tinhtrang}&ghichu=${ghichu}`;
    // API_AUTH.get(link).then((res) => {
    //   var uri = "data:application/vnd.ms-excel," + encodeURIComponent(res.data);
    //   var downloadLink = document.createElement("a");
    //   downloadLink.href = uri;
    //   downloadLink.download = "DanhSachTaiSan.xls";
    //   document.body.appendChild(downloadLink);
    //   downloadLink.click();
    //   document.body.removeChild(downloadLink);
    // });
    API_AUTH.get(link).then((res) => {
      setDataPrint(res.data);
      setTimeout(downExcel(), 2000);
    });
  };

  const downExcel = () => {
    var uri =
      "data:application/vnd.ms-excel," +
      encodeURIComponent(document.getElementById("htmlExcel").outerHTML);
    var downloadLink = document.createElement("a");
    downloadLink.href = uri;
    downloadLink.download =
      "DanhSachTaiSan_" + moment().format("YYYYMMDDHHmm") + ".xls";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <>
      <a
        href={() => false}
        onClick={xuatExcel()}
        className="icon-bgnew color-print1"
      >
        <PopoversBootrap
          contentText="Xuất danh sách"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img src="/app-assets/images/icon-tai-xuong-v2.png" />
        </PopoversBootrap>
      </a>
      <div style={{ display: "none", color: "#000000" }}>
        <TaiSanPrint ref={componentRef} dataPrint={dataPrint} />
      </div>
    </>
  );
};
